import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
	FETCH_BOOKING_DATA: createAsyncActionConstants('FETCH_BOOKING_DATA'),
	FETCH_RESET_DATA: createAsyncActionConstants('FETCH_RESET_DATA'),
	FETCH_BOOKING_DETAILS: createAsyncActionConstants(
		'FETCH_BOOKING_DETAILS',
	),
	FETCH_COST_REVENUE: createAsyncActionConstants('FETCH_COST_REVENUE'),
	ADD_COST_REVENUE: createAsyncActionConstants('ADD_COST_REVENUE'),
	EDIT_COST_REVENUE: createAsyncActionConstants('EDIT_COST_REVENUE'),
	UPDATE_CHARGES: createAsyncActionConstants('UPDATE_CHARGES'),
	REFRESH_ATHENA_RATES: createAsyncActionConstants(
		'REFRESH_ATHENA_RATES',
	),
	FETCH_DISTRIBUTION_DATA: createAsyncActionConstants(
		'FETCH_DISTRIBUTION_DATA',
	),
	VALIDATE_JOB_STATUS: createAsyncActionConstants('VALIDATE_JOB_STATUS'),
	FETCH_REVENUE_DATA: createAsyncActionConstants('FETCH_REVENUE_DATA'),
	FETCH_COST_DATA: createAsyncActionConstants('FETCH_COST_DATA'),
	FETCH_EXPORTJOBS_CHARGE_REV: createAsyncActionConstants(
		'FETCH_EXPORTJOBS_CHARGE_REV',
	),
	FETCH_EXPORTJOBS_CHARGE_COST: createAsyncActionConstants(
		'FETCH_EXPORTJOBS_CHARGE_COST',
	),
	FETCH_EQUIPMENTS_EXPORTJOB: createAsyncActionConstants(
		'FETCH_EQUIPMENTS_EXPORTJOB',
	),
	VALIDATE_CBL_EDIT_STATUS: createAsyncActionConstants(
		'VALIDATE_CBL_EDIT_STATUS',
	),
	GET_CHARGE_ITEM_DETAILS_EDIT: createAsyncActionConstants(
		'GET_CHARGE_ITEM_DETAILS_EDIT',
	),
	DELETE_CHARGE_ITEMS_CBL: createAsyncActionConstants(
		'DELETE_CHARGE_ITEMS_CBL',
	),
    FETCH_PENDING_PROCESSING_MESSAGES: createAsyncActionConstants(
        'FETCH_PENDING_PROCESSING_MESSAGES',
    ),
};
